export const ProductListItemAvailability = (props) => {
  return availability();
  function availability() {
    if (props.product.in_stock) {
      return (
        <div className="availability" style={{ paddingTop: 0 }}>
          <strong className="available-quantity" style={{ marginRight: 0 }}>
            {props.product.quantity_in_stock_label}
          </strong>

          <div className="availability-state.in-stock">
            u vás doma {props.product.delivery_date}
          </div>
        </div>
      );
    } else if (
      props.product.best_supplier_in_stock ||
      props.product.supplier_in_stock
    ) {
      return (
        <div className="availability" style={{ paddingTop: 0 }}>
          <strong className="available-quantity" style={{ marginRight: 0 }}>
            {props.product.quantity_in_stock_label}
          </strong>

          <div className="availability-state in-stock">
            u vás doma {props.product.delivery_date}
          </div>
        </div>
      );
    } else {
      return (
        <div className="availability" style={{ paddingTop: 0 }}>
          <strong
            className="availability-state supplier-in-stock warning"
            style={{ marginRight: 0 }}
          >
            Neznámá dostupnost
          </strong>
        </div>
      );
    }
  }
};
